<template>
  <c-row>
    <c-col col="6">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <nav-back label="COA" url="/account/coa" />
            <strong>Chant of Accounting</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Parent</label>
            <select-x
              url="/api/v1/coa"
              :query="{ parent: true }"
              v-model="data.parent"
            />
          </div>
          <div class="form-group">
            <label>Code</label>
            <input type="text" v-model="data.code" class="form-control" />
          </div>
          <div class="form-group">
            <label>Name</label>
            <input type="text" v-model="data.name" class="form-control" />
          </div>
          <div class="form-group">
            <label>Link To</label>
            <select-x
              type="text"
              v-model="data.link_to"
              url="/api/v1/coa/link/items"
            />
          </div>
          <div></div>
        </c-card-body>
        <c-card-footer>
          <SURButton
            :object="data"
            @onSave="save"
            @onUpdate="update"
            @onReset="reset"
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Loader from '../../components/Loader.vue';
import NavBack from '../../components/NavBack.vue';
import SelectX from '../../components/SelectX.vue'
import SURButton from '../../components/SURButton.vue';
import { showErrorMessage, successMessage } from '../../lib/helpers';
import { HTTPAUTH } from '../../lib/httplib';
export default {
  components: {
    SelectX,
    SURButton,
    Loader,
    NavBack
  },
  data () {
    return {
      data: {},
      coas: [],
      loading: true,
    };
  },
  computed: {
    paramId () {
      return this.$route.query.id;
    },
  },
  created () {
    this.getDetail();
  },
  methods: {
    getDetail () {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/coa/${this.paramId}`).then(res => {
        this.data = res.data.data;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    save () {
      this.loading = true;
      if (this.data.parent) {
        this.data.coa_id = this.data.parent.id;
      }
      HTTPAUTH.post('/api/v1/coa', this.data).then(res => {
        this.data = res.data.data;
        this.$router.push({ query: { id: this.data.id } })
        this.loading = false;
        successMessage('Berhasil menyimpan data')
      }).catch((eres) => {
        showErrorMessage(eres)
        this.loading = false;
      })
    },
    update () {
      this.loading = true;
      if (this.data.parent) {
        this.data.coa_id = this.data.parent.id;
      }
      HTTPAUTH.put(`/api/v1/coa/${this.paramId}`, this.data).then(res => {
        this.data = res.data.data;
        this.$router.push({ query: { id: this.data.id } })
        this.loading = false;
        successMessage('Berhasil menyimpan data')
      }).catch((eres) => {
        showErrorMessage(eres)
        this.loading = false;
      })
    },
    reset () {
      this.data = {}
      this.$router.push({ path: '/account/coa/add' })
    },
  }
};
</script>